import { createGlobalStyle } from 'styled-components'
import colors from '../../tokens/colors'

export const Html = createGlobalStyle`
  html {
    font-size: 10px;
    line-height: 1.5;
  }
`

export const Body = createGlobalStyle`
  body {
    color: initial;
    font-family: initial;
    font-size: initial;
    font-weight: initial;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0.4rem;
    }

    ::-webkit-scrollbar-thumb {
      background: ${colors.neutralColorLowLight};
      border-radius: 0.4rem;
    }
  }
`
